import gsap from 'gsap/dist/gsap.min'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.min'
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin.min"
import Swiper from 'swiper/bundle';
import MagicGrid from "magic-grid"

// import Accordion from 'service/ui/Accordion';
import Header from 'service/ui/Header';
import Loader from 'service/ui/Loader';
import Menu from 'service/ui/Menu';
import PageTop from 'service/ui/PageTop';
import Parallax from 'service/ui/Parallax';
import ResizeReload from 'service/ui/ResizeReload';
import SubpageOpening from 'service/ui/SubpageOpening';
import Slider from 'service/ui/Slider';
import SmoothScroll from 'service/ui/SmoothScroll';
import Modal from 'service/ui/Modal';
import Grid from 'service/ui/Grid';
import Sort from 'service/ui/Sort';
import Home from 'service/pages/Home/index';
import Solution from 'service/pages/Solution';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

window.gsap = gsap
window.ScrollTrigger = ScrollTrigger
window.ScrollToPlugin = ScrollToPlugin
window.Swiper = Swiper;
window.MagicGrid = MagicGrid;

window.addEventListener('DOMContentLoaded', () => {
  // new Accordion();
  new Header();
  new Loader();
  new Menu();
  new PageTop();
  new Parallax();
  new ResizeReload();
  new SubpageOpening();
  new Slider();
  new SmoothScroll();
  new Modal();
  new Grid();
  new Sort();
  new Home();
  new Solution();
});
